/**
 * NotFoundPage: catch-all for any route that doesn't match — a stale
 * bookmark, a typo'd URL, a deleted wedding's old link. Without this,
 * React Router renders nothing at all for an unmatched path, which is a
 * blank white screen with zero explanation — about as far from
 * "professional software" as a failure mode gets.
 */

import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-3 bg-ivory-100 px-6 text-center">
      <p className="font-body text-xs uppercase tracking-[0.2em] text-ink-400">
        The Venue at Lilly Lou&rsquo;s
      </p>
      <h1 className="font-display text-2xl text-ink-700">We couldn&rsquo;t find that page</h1>
      <p className="font-body text-sm text-ink-500">
        The link may be out of date, or the page may have moved.
      </p>
      <Link
        to="/"
        className="mt-2 rounded bg-evergreen-600 px-4 py-2 font-body text-sm font-medium text-ivory-50 hover:bg-evergreen-700"
      >
        Back to your weddings
      </Link>
    </div>
  );
}
